import React from 'react';
import PropTypes from 'prop-types';

import {Button} from 'views/components';

import {Translate} from 'views/module';

import {AddCircleOutline as AddCircleOutlineIcon} from 'views/icons';

const AuthNotSetup = (props) => {
  const {onClick} = props;

  return (
    <Button
      startIcon={<AddCircleOutlineIcon />}
      onClick={onClick}
      sx={{
        mx: 2,
        my: 1,
      }}
    >
      <Translate expression="caregiver.CaregiverDetail.Settings.Auth.SetupAuth" />
    </Button>
  );
};

AuthNotSetup.propTypes = {
  onClick: PropTypes.func.isRequired,
};
export default React.memo(AuthNotSetup);
